import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { Person, ReduxState } from 'types';
import ConfirmAPI from '../../utils/api/ConfirmAPI';
import Page404 from '../Layout/Pages/Errors/Page404';

interface Props {
  currentProxyPerson?: Person;
}

// /pid/<platform_id>[/<tab>]: resolves the person and replaces the location with their canonical url.
const PlatformIdProfile: FC<Props> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch<{ platformId: string }>();
  const [notFound, setNotFound] = useState(false);

  const platformId = match.params.platformId;
  const subroute = location.pathname.slice(match.url.length);

  useEffect(() => {
    ConfirmAPI.sendRequestToConfirm(
      'GET',
      ConfirmAPI.getObjectUrl(
        ConfirmAPI.OBJECT_TYPES.PEOPLE,
        platformId,
        { platform_id: 'true' },
        props.currentProxyPerson
      ),
      {},
      (person) => {
        if (person?.url) {
          history.replace(
            person.url + subroute + location.search + location.hash
          );
        } else {
          setNotFound(true);
        }
      }
    );
  }, [
    history,
    location.hash,
    location.search,
    platformId,
    props.currentProxyPerson,
    subroute,
  ]);

  return notFound ? <Page404 /> : <></>;
};

const mapStateToProps = (state: ReduxState) => {
  const { currentProxyPerson } = state;

  return { currentProxyPerson };
};

export default connect(mapStateToProps)(React.memo(PlatformIdProfile));
